export default "__VITE_ASSET__D181Uwbf__"